"use strict";

exports.__esModule = true;
exports.formatValue = formatValue;
exports.formatPercentValue = formatPercentValue;
exports.formatNumberValue = formatNumberValue;
exports.formatTimeValue = formatTimeValue;
exports.formatDateValue = formatDateValue;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatValue(value, type, language = "nb") {
  if (type === "TIME") {
    return formatTimeValue(value);
  }

  if (type === "DATE") {
    return formatDateValue(value);
  }

  if (type === "PERCENT") {
    return formatPercentValue(value);
  }

  return formatNumberValue(value);
  return value.toLocaleString(language);
}

function formatPercentValue(value) {
  value = parseFloat(value);
  return value.toFixed(1) + "%";
}

function formatNumberValue(value) {
  value = parseFloat(value);
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function formatTimeValue(value) {
  var sec_num = parseInt(value, 10);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours) {
    return hours + 'h ' + minutes + 'm ' + seconds + 's';
  }

  if (minutes) {
    return minutes + 'm ' + seconds + 's';
  }

  return seconds + 's';
}

function formatDateValue(value, format = "") {
  //    const date = moment(value).format('YYYY-MM-DD')
  let date = value,
      year;
  year = (0, _moment.default)(date).format('Y');
  date = (0, _moment.default)(date).format('LL').replace(year, '').replace(',', '');
  return date;
}